import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status?: ReduxStateType;
  formData: {
    requestCode: string;
    employeeCode: string;
  };
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  formData: {
    requestCode: "",
    employeeCode: "",
  },
};

const forwardEvaluationSlice = createSlice({
  name: "forwardEvaluation",
  initialState,
  reducers: {
    updateFormForwardEvaluation: (state, action) => {
      state.formData = {
        ...state.formData,
        ...action.payload,
      };
    },

    forwardEvaluationStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    forwardEvaluationSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    forwardEvaluationFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  updateFormForwardEvaluation,
  forwardEvaluationStart,
  forwardEvaluationSuccess,
  forwardEvaluationFailed,
} = forwardEvaluationSlice.actions;

export default forwardEvaluationSlice.reducer;
